
import { Component, Vue } from 'vue-property-decorator'

import BacHeaderWithMenue from '@/templates/BacHeaderWithMenue.vue'
import ChatComponent from '@/components/chat/ChatComponent.vue'
import Waiting from '@/components/Waiting.vue'
import { checkAllowedToAccessPermission } from '@/lib/utils/RallyRoundAccess'

@Component({
  components: {
    BacHeaderWithMenue,
    ChatComponent,
    Waiting
  }
})
export default class Chat extends Vue {
  mounted () {
    checkAllowedToAccessPermission(this.$route.params.rallyRoundId)
  }
}
